import { PageRatingComponentOptions } from "./models/page-rating-options.model";
import { PageRatingComponentModel } from "./models/page-rating.model";

export class PageRatingComponent {
    public static SELECTOR: string = ".js-pcg-rating";

    private _currentContext: JQuery = $();

    private _moduleOptions: PageRatingComponentOptions = {
        submitRatingUrl: "",
        pageId: null,
        modalMessages: []
    };

    private _classMap = {
        js: {
            control: ".js-pcg-rating__control",
            modalWindow: ".js-pcg-rating__modal",
            submitComment: ".js-pcg-rating__submit-comment",
            comment: ".js-pcg-rating__comment",
            modalTitle: ".js-pcg-rating__modal-title",
            modalSubTitle: ".js-pcg-rating__modal-subtitle"
        },
        css: {
            beforeChoice: "pcg-vote-element--beforeChoice",
            afterChoice: "pcg-vote-element--afterChoice",
            selected: "pcg-vote-element--selected"
        }
    };

    private _controls: JQuery = $();
    private _modal: JQuery = $();
    private _modalControls: JQuery = $();
    private _modalTitle: JQuery = $();
    private _modalSubTitle: JQuery = $();
    private _chosenStar: JQuery = $();

    private _isAlreadyRated = false;

    private _data: PageRatingComponentModel = {
        rating: null,
        comment: ""
    };

    private postRating(data: PageRatingComponentModel): void {
        this._isAlreadyRated = true;

        const comment = {
            message: data.comment,
            recommendation: ""
        };

        void $.ajax({
            type: "POST",
            url: this._moduleOptions.submitRatingUrl,
            data: {
                pageId: this._moduleOptions.pageId,
                rating: data.rating,
                comment: JSON.stringify(comment)
            }
        }).fail(() => {
            this._isAlreadyRated = false;
        });
    }

    private changeUiState(chosenStar: JQuery, ratingValue: number): void {
        chosenStar.addClass(this._classMap.css.selected);

        const modalTitle = this._moduleOptions.modalMessages[ratingValue - 1].title;
        const modalSubTitle = this._moduleOptions.modalMessages[ratingValue - 1].subTitle;

        this._controls.removeClass(this._classMap.css.beforeChoice);
        this._controls.addClass(this._classMap.css.afterChoice);

        this._modalControls.eq(ratingValue - 1).addClass(this._classMap.css.selected);
        this._modalTitle.text(modalTitle);
        this._modalSubTitle.text(modalSubTitle);

        this._modal.modal("show");
    }

    private setRating(): void {
        if (!this._isAlreadyRated) {
            if (this._chosenStar.data().ratingValue) { // TODO: Delete JS class from stars in modal, then delete this check
                this._data.rating = this._chosenStar.data().ratingValue as number;
                console.log("rating " + this._data.rating);
                this.changeUiState(this._chosenStar, this._data.rating);
            }
        }
    }

    private setComment(): void {
        this._data.comment = $(this._classMap.js.comment, this._currentContext).val() as string;
        this._modal.modal("hide");
    }

    private bindEvents(): void {
        const control = $(this._classMap.js.control, this._currentContext);

        control.on("click", (e) => {
            this._chosenStar = $(e.target).closest(this._classMap.js.control);
            this.setRating();
        });

        $(this._classMap.js.submitComment, this._currentContext).on("click", () => this.setComment());

        this._modal.on("hide.bs.modal", () => {
            this.postRating(this._data);
        });
    }

    private initContext(): void {
        this._controls = $(this._classMap.js.control, this._currentContext);
        this._modal = $(this._classMap.js.modalWindow, this._currentContext);

        this._modalControls = $(this._classMap.js.control, this._modal);
        this._modalTitle = $(this._classMap.js.modalTitle, this._modal);
        this._modalSubTitle = $(this._classMap.js.modalSubTitle, this._modal);
    }

    public init(context: JQuery, options: object): void {
        this._currentContext = context || this._currentContext;

        $.extend(this._moduleOptions, options);

        this.initContext();
        this.bindEvents();
    }
}
